/* @ngInject */
export class ModalDialogController {
  /* @ngInject */
  constructor ($scope, $anchorScroll) {

    this.$scope = $scope
    this.$anchorScroll = $anchorScroll

    this.notToggleable = true
    this.closeOnClickOverlay = false
    this.hasCloseButton = true

    this.doOnChangeErrorMessage = this.doOnChangeErrorMessage.bind(this)
    this.watcher = this.$scope.$watch('ModalDialogController.content', this.doOnChangeErrorMessage)

  }

  $onInit() {
    console.log('ModalDialogController visible', this.visible)
    console.log('ModalDialogController content', this.content)
  }


doOnChangeErrorMessage() {
  this.visible = false 

  if(this.content.message == '' || this.content.message == null)
    return
  this.messageContext = this.content.context 
  this.visible = true 
}


/**
* Clic à l'extérieur de la modale
*/
  onClickOverlay() {
    if(!this.closeOnClickOverlay)
      return;
    this.hideModal()


  }

onClose() {
  return this.hideModal()

}

/**
* fermeture de la modale. S'il y a un contexte, on force une navigation vers le "panel" correspondant 
*/
hideModal() {
    this.visible = false

    console.log("ModalDialogController.hideModal, context:", this.messageContext)

    if(!this.messageContext)
      return
    if(!this.messageContext.panel)
      return

    if(this.messageContext.panel)
      this.parentSimulator.smoothScrollToPanel(this.messageContext)
  }


/**
*
*/
  toggle () {
    if(this.notToggleable) 
        return;
    this.visible = !this.visible
  }

}


// WEBPACK FOOTER //
// ./src/client/common/uiComponents/ModalDialog/modal-dialog.controller.js